/**
 * Google Ads Product Recommendations - Optimized Version
 * 
 * Performance optimizations:
 * - No jQuery dependency (vanilla JS)
 * - Uses pre-computed API URL from data attribute (no DOM search delay)
 * - Exits immediately for non-Google traffic (zero overhead)
 * - Single fetch call (no retry timeouts)
 * - Deferred script loading
 */
(function() {
    'use strict';

    // Check for Google/Bing Ads traffic IMMEDIATELY - exit fast for regular traffic
    var params = new URLSearchParams(window.location.search);
    var utmSource = params.get('utm_source');
    if (utmSource !== 'google' && utmSource !== 'bing') {
        return; // Exit immediately - zero overhead for regular traffic
    }

    console.log('[sg-product] Paid Ads traffic detected (' + utmSource + ') — loading recommendations');

    // Get the API URL from the script tag's data attribute (pre-computed by Liquid)
    var scriptTag = document.currentScript || document.querySelector('script[data-recs-url]');
    var apiUrl = scriptTag ? scriptTag.getAttribute('data-recs-url') : null;

    // Fallback: try to find it in DOM if data attribute not available
    if (!apiUrl) {
        var recsBlock = document.querySelector('[data-recommendations-block][data-url]');
        if (recsBlock) {
            apiUrl = recsBlock.getAttribute('data-url');
        }
    }

    if (!apiUrl) {
        console.log('[sg-product] Google Ads: no recommendations URL found');
        return;
    }

    /**
     * Initialize the Google Ads Swiper with cloned product cards
     */
    function initGoogleAdsSwiperClone() {
        var wrapper = document.getElementById('fdp-google-ads-clone');
        if (!wrapper) {
            console.log('[sg-product] Google Ads: wrapper element not found');
            return;
        }

        var swiperEl = wrapper.querySelector('.fdp-google-ads-swiper-clone');
        if (!swiperEl) return;

        // Already initialized?
        if (swiperEl.swiper) return;

        // Already fetching?
        if (wrapper.dataset.fetching === 'true') return;

        // Mark as fetching
        wrapper.dataset.fetching = 'true';
        console.log('[sg-product] Google Ads: fetching recommendations from: ' + apiUrl);

        fetch(apiUrl)
            .then(function(response) {
                if (!response.ok) throw new Error('HTTP ' + response.status);
                return response.text();
            })
            .then(function(html) {
                // Parse the HTML response
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');

                // Find swiper slides from the PRODUCT recommendations swiper
                var sourceSlides = doc.querySelectorAll('.fdp-products-recommendations-swiper .swiper-slide');
                console.log('[sg-product] Google Ads: found ' + sourceSlides.length + ' slides in .fdp-products-recommendations-swiper');

                if (sourceSlides.length === 0) {
                    // Fallback: try .halo-recommendations-block .swiper-slide
                    sourceSlides = doc.querySelectorAll('.halo-recommendations-block .swiper-slide');
                    console.log('[sg-product] Google Ads: fallback .halo-recommendations-block .swiper-slide — ' + sourceSlides.length + ' found');
                }

                if (sourceSlides.length === 0) {
                    // Last fallback: try any .product inside recommendations block
                    sourceSlides = doc.querySelectorAll('.halo-recommendations-block .product');
                    console.log('[sg-product] Google Ads: last fallback .halo-recommendations-block .product — ' + sourceSlides.length + ' found');
                }

                if (sourceSlides.length === 0) {
                    console.log('[sg-product] Google Ads: no product cards found in API response');
                    wrapper.dataset.fetching = 'false';
                    return;
                }

                // Clone slides into our empty swiper-wrapper
                var targetWrapper = swiperEl.querySelector('.swiper-wrapper');
                if (!targetWrapper) return;

                // Clear any previous content
                targetWrapper.innerHTML = '';

                sourceSlides.forEach(function(slide, index) {
                    // Wrap in swiper-slide if not already
                    var slideEl;
                    if (slide.classList.contains('swiper-slide')) {
                        slideEl = slide.cloneNode(true);
                    } else {
                        slideEl = document.createElement('div');
                        slideEl.className = 'swiper-slide';
                        slideEl.appendChild(slide.cloneNode(true));
                    }
                    targetWrapper.appendChild(slideEl);

                    var productTitle = slideEl.querySelector('.card-title a, .card-information__text a, .product-card-title a, h3 a, h2 a');
                    var titleText = productTitle ? productTitle.textContent.trim() : '(unknown)';
                    console.log('[sg-product] Google Ads clone: card #' + (index + 1) + ' — ' + titleText);
                });

                // Prepend the header before the swiper element
                if (!wrapper.querySelector('.fdp-google-ads-slider-header')) {
                    var headerDiv = document.createElement('div');
                    headerDiv.className = 'fdp-google-ads-slider-header';
                    headerDiv.innerHTML = '<span class="h2">Customers Also Viewed</span>';
                    swiperEl.parentNode.insertBefore(headerDiv, swiperEl);
                }

                // Show the wrapper
                wrapper.style.display = 'block';

                // Initialize Swiper
                if (typeof Swiper !== 'undefined') {
                    new Swiper(swiperEl, {
                        slidesPerView: 'auto',
                        speed: 600,
                        loop: true,
                        spaceBetween: 12,
                        //grabCursor: true,
                        pagination: {
                            el: swiperEl.querySelector('.swiper-pagination'),
                            clickable: true,
                            enabled: true,
                        },
                        navigation: {
                            nextEl: swiperEl.querySelector('.swiper-button-next'),
                            prevEl: swiperEl.querySelector('.swiper-button-prev'),
                            enabled: false,
                        },
                        breakpoints: {
                            551: {
                                pagination: {
                                    enabled: false,
                                },
                                navigation: {
                                    enabled: true,
                                }
                            }
                        }
                    });
                    console.log('[sg-product] Google Ads Swiper initialized with ' + sourceSlides.length + ' slides');
                } else {
                    console.log('[sg-product] Google Ads: Swiper library not loaded yet');
                }
            })
            .catch(function(err) {
                console.error('[sg-product] Google Ads: fetch failed —', err);
                wrapper.dataset.fetching = 'false';
            });
    }

    // Run when DOM is ready (script is deferred, so DOM should be ready)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initGoogleAdsSwiperClone);
    } else {
        // DOM already ready, run immediately
        initGoogleAdsSwiperClone();
    }

})();
